import axios from 'axios';
import Vue from 'vue'
import qs from 'qs'
import router from '@/router'
import store from '@/store';
import {
	Loading
} from 'element-ui';
import Message from '@/utils/message.js';
import microService from '@/assets/json/microService.json';
import * as Cookie from "@/localCache/cookie";

let loading // 定义loading变量

function startLoading() { //使用Element loading-start 方法
	loading = Loading.service({
		fullscreen: true,
		lock: true,
		background: 'rgba(0, 0, 0, 0.15)',
		customClass: 'loading-fullscreen-mask'
	})
}

function endLoading() {
	loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		startLoading()
	}
	needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		endLoading()
	}
}

// 创建axios实例
let service = axios.create({
	baseURL: process.env.VUE_APP_URL, // api的base_url
	timeout: 30000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
	// 全局loading
	if (!(config.params && config.params.loading === true)) {
		showFullScreenLoading();
	}

	// formData 参数格式转换
	if (config.headers["Content-Type"] &&
		config.headers["Content-Type"].indexOf('application/x-www-form-urlencoded') > -1) {
		config.data = qs.stringify(config.data)
	}

	// 判断是否属于白名单，如果属于则在url中添加/whitelist，不属于则在headers中添加token
	if (config.params && config.params.whitelist === true) {
		delete config.params.whitelist
		config.url = config.url + '/whitelist'
	} else if (Cookie.getToken()) {
		config.headers = Object.assign({
			'Authorization': Cookie.getToken() // 携带权限参数
		}, config.headers ? config.headers : new Object());
	}

	// 配置版本
	config.headers["ylc-version"] = store.state['ylc-version'];
	config.headers["version"] = Vue.prototype.$version;

	return config
}, error => {
	Promise.reject(error)
});


// 退出登录
const handleLogout = () => {
  store.dispatch('logout');
  router.push('/home').catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

// respone拦截器
service.interceptors.response.use(
	response => {
		setTimeout(function() {
			tryHideFullScreenLoading()
		}, 300);
		// 访问服务器失败
		if (response.status < 200 || response.status > 206) {
			Message.error({
				message: response.status + " ：访问服务器错误。",
				duration: 5 * 1000,
				showClose: true
			})
			return Promise.resolve('error')
		} else {
			// 成功返回数据
			if (response.data) {
				if (Object.prototype.hasOwnProperty.call(response.data, 'code') === false) {
					return Promise.resolve(response)
				} else if (response.data.code == 'A0301') {
					handleLogout();
				} else if (response.data.code !== '00000') {
					Message.error({
						message: response.data.code + " ：" + response.data.message,
						duration: 5 * 1000,
						showClose: true
					})
					if (response.data.code === 'A0230' || response.data.code == 'A0300' || response.data.code == 'A0212' || response.data.code == 'A0231') {
						handleLogout();
					}
				}
			}
			return Promise.resolve(response.data)
		}
	},
	error => {
		tryHideFullScreenLoading();
		if (error.response == null) {
			return Promise.reject(error)
		} else if (error.response.config.params && error.response.config.params.error === false) {
			return Promise.reject(error.response.data)
		}
		// 对响应错误做点什么
		if (error.response.status === 401) {
			if (router.history && router.history.current && router.history.current.path !== '/') {
				Message.error({
					message: "401 : 未授权！",
					duration: 5 * 1000,
					showClose: true
				})
			}
			handleLogout();
		} else if (error.response.status === 403) {
			Message.error({
				message: "403 : 没有权限访问！",
				duration: 5 * 1000,
				showClose: true
			})
			handleLogout();
		} else if (error.response.status === 500) {
			Message.error({
				message: "500 : 服务器错误！",
				duration: 5 * 1000,
				showClose: true
			})
		} else if (error.response.status === 503) {
			let serviceKey = Object.keys(microService).find(key => error.response.config.url.indexOf(key) > -1);
			Message.error({
				message: serviceKey ? "503 ：" + microService[serviceKey] + '服务不可用！' : "503 ：服务不可用！",
				duration: 5 * 1000,
				showClose: true
			})
		} else {
			var key = Object.prototype.toString.call(error.response.data);
			if (key == "[object Object]") {
				Message.error({
					message: error.response.data.status + " : " + error.response.data.error,
					duration: 5 * 1000,
					showClose: true
				})
			} else if (key == "[object String]") {
				Message.error({
					message: error.response.status + " : " + error.response.statusText,
					duration: 5 * 1000,
					showClose: true
				})
			} else {
				Message.error({
					message: "系统错误",
					duration: 5 * 1000,
					showClose: true
				})
			}
		}
		return Promise.reject(error.response.data)
	}
);

export default service;
